import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  clearStorage(): void {
    window.sessionStorage.clear();
  }

  public saveItem(key: string, value: any): void {
    window.sessionStorage.removeItem(key);
    window.sessionStorage.setItem(key, value);
  }

  public deleteItem(key: string): void {
    window.sessionStorage.removeItem(key);
  }

  public getItem(key: string): any {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(key);
  }
}
